module.exports = __webpack_public_path__ + "static/img/qrcode.336b6dcb.jpg";